import { createBlueprint as r } from "@made-people/blueprint";
const o = r({
  slots: {
    wrapper: "flex flex-row gap-8",
    logo: "h-4"
  },
  variants: {}
});
export {
  o as partnerLogosTemplate1Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
